import styled from 'styled-components';
import { AllieText } from '../Text';

export const StyledAllieWidget = styled.div`
  display: block;
  background: var(--allie-color-light-main);
  border-radius: 8px;
  padding: 16px;
  width: 100%;

  @media only screen and (min-width: 768px) and (max-width: 1180px) {
    min-height: 197px;
    margin-bottom: 15px;
  }
`;

export const StyledAllieWidgetHeader = styled.header`
  display: flex;
  align-items: center;
  column-gap: 16px;
  margin-bottom: 16px;
`;

export const StyledAllieWidgetIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 9px;
`;

export const StyledAllieWidgetLeftSide = styled.div`
  display: flex;
  flex-direction: column;
  max-width: none;
`;

export const StyledAllieWidgetLeftSideSubtitle = styled(AllieText)`
  display: flex;
  padding: 0 25px;
  font-weight: 600;
  font-size: 25px;
  font-family: var(--ion-font-family, inherit);
  white-space: nowrap;
`;

export const StyledAllieWidgetLeftSideContent = styled.div`
  display: flex;
  font-family: var(--ion-font-family, inherit);
  flex-wrap: wrap;
  gap: 8px;
`;

export const StyledAllieWidgetRightSide = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  .view-all {
    position: relative;
    cursor: pointer;
    width: 100%;
    text-align: start;
    font-weight: 600;
    font-size: 16px;
    top: 0;
    color: var(--allie-color-primary-80);
  }
`;
